import { useTotemSectorActions } from '../TotemSector/useTotemSectorActions';
import { useInboxActions } from '../Inbox/useInboxActions';
import { TotemSectorMutationArgs } from '../../models';
import { useUserInfo } from '@/hooks';

interface AttendParams {
  totemSectorBody: TotemSectorMutationArgs;
  inboxId: string;
  isAlreadyTaken?: boolean;
}

const useAttend = () => {
  const { onServeCustomer, isServeCustomerLoading, onToggleInboxIsTaken } =
    useInboxActions();
  const { onAttendCustomer, isLoadingAttend } = useTotemSectorActions();

  const { firstName, lastName, id } = useUserInfo();

  const onAttend = async ({
    totemSectorBody,
    inboxId,
    isAlreadyTaken = false,
  }: AttendParams) => {
    const attentionUser = `${firstName} ${lastName}`.trim();

    if (!isAlreadyTaken) {
      const isTaken = await onToggleInboxIsTaken({
        inboxId,
        takenById: id,
        takenByName: attentionUser,
      });

      if (!isTaken) return false;
    }

    const isServed = await onServeCustomer({ inboxId, attentionUser });
    if (!isServed) return false;

    await onAttendCustomer(totemSectorBody);
    return true;
  };

  const { onMarkAsPending, isMarkAsPendingLoading } = useInboxActions();
  const { onMarkAsWaiting, isMarkAsWaitingLoading } = useTotemSectorActions();

  const onCancelAttend = async ({
    totemSectorBody,
    inboxId,
    isAlreadyTaken = false,
  }: AttendParams) => {
    await onMarkAsPending(inboxId);
    await onMarkAsWaiting(totemSectorBody);

    if (!isAlreadyTaken) {
      const attentionUser = `${firstName} ${lastName}`.trim();
      await onToggleInboxIsTaken({
        inboxId,
        takenById: id,
        takenByName: attentionUser,
      });
    }

    localStorage.removeItem('TOTEM_SECTOR_ID');
  };

  return {
    onAttend,
    isAttendCustomerLoading: isServeCustomerLoading || isLoadingAttend,
    onCancelAttend,
    isCancelAttendLoading: isMarkAsPendingLoading || isMarkAsWaitingLoading,
  };
};

export default useAttend;
